import React, { useEffect, useState } from "react";
import classes from "./style/LoadingPage.module.css";
import { useAppDispatch } from "../../store/reduxHooks";
import {
  DATA_ALL,
  // TypeInitialState,
} from "../../store/slices/authSlice/authSlice";
import Codepen from "./Codepen";
import Crazy from "./Crazy";
import Rainbow from "./Rainbow";
import Preloader from "./Preloader";
import Building from "./Building";
import { useGetPermissionQuery } from "../../store/api/permission.api";
// import { useSelector } from "react-redux";
const LoadingPage = () => {
  const { isLoading, data, error } = useGetPermissionQuery(undefined);
  interface InitialProps {
    building: JSX.Element;
    codepen: JSX.Element;
    rainbow: JSX.Element;
    crazy: JSX.Element;
    preloader: JSX.Element;
  }
  const initialValues: InitialProps = {
    building: <Building />,
    codepen: <Codepen />,
    rainbow: <Rainbow />,
    crazy: <Crazy />,
    preloader: <Preloader />,
  };
  // DATA_ALL_PAGE
  const [match] = useState<keyof InitialProps>("building");
  const dispatch = useAppDispatch();
  // const isAuthenticated = useSelector(
  //   (state: { authSlice: TypeInitialState }) => state.authSlice
  // );
  const isInitialValueMatch = () => {
    if (initialValues.hasOwnProperty(match)) {
      return initialValues[match];
    }
    return <Building />;
  };
  useEffect(() => {
    if (!isLoading && !error) {
      dispatch(DATA_ALL(data));
    }
    if (error?.status) {
      localStorage.clear();
      window.location.replace("/login");
    }
  }, [dispatch, data, isLoading, error]);
  return (
    <div className={classes.row}>
      <div className={classes.wrapperPageLoading}>{isInitialValueMatch()}</div>
    </div>
  );
};

export default LoadingPage;
